/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { components } from "react-select";

const NegativeMarginFix = styled("div")`
    margin-top: -6px;
    display: flex;
    flex-wrap: wrap;
    label: NegativeMarginFix;
    align-items: center;

    // To ensure we don't add a scrollbar when the placeholder is visible. The placeholder
    // is positioned out of flow so it doesn't contribute height/width.
    min-width: 1px;
    min-height: 18px;

    // Ensure the Tokens don't overflow.
    overflow: hidden;
`;

const MouseTrap = styled("div")`
    overflow: auto;
    max-height: 62px;
`;

// this is checking if the event is happening on the scollbar, and preventing the mousedown from
// opening or closing the menu if the user is interacting with the scrollbar
function onMouseDown(e: React.MouseEvent<HTMLDivElement>) {
    const parent = e.currentTarget.getBoundingClientRect();
    const child = e.currentTarget.firstChild as HTMLDivElement;
    const x = e.clientX - parent.left;
    if (x > child.offsetWidth) {
        e.stopPropagation();
    }
}

// Ideally we'd use styled(components.ValueContainer)``, but for some reason the ValueContainer
// component doesn't play nice with it. So, css prop it is!
/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const MultiValueContainer: typeof components.ValueContainer = (props) => (
    <components.ValueContainer
        {...props}
        css={css`
            max-height: 62px;
            padding: 0;
        `}
    >
        <MouseTrap onMouseDown={onMouseDown}>
            <NegativeMarginFix>{props.children}</NegativeMarginFix>
        </MouseTrap>
    </components.ValueContainer>
);
